import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const sassy: Partial<CaptionStyles> = {
  theme_preset: 'sassy',
  pageStyle: {
    color: '#ffffff'
  },
  wordStyle: {
    active: {
      color: '#ffffff'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Box,
    highlightBoxStyle: {
      background: '#da45ec',
      borderRadius: '8px',
      inset: '-6px -12px'
    }
  },
  letterStyle: undefined,
  font_location: getFontFullPath('AlbertSans.ttf'),
  caps: false,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.Spring
  }
};

export default sassy;
